// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { useViewportContext } from '../../contexts/ViewportContext';
import { getLang } from '../../i18n/l10n';
import { Licences, Locales } from '../../types/common';
import type { Licence } from '../../types/common';
import LegalDe from '../LegalDe';
import LegalEs from '../LegalEs';
import LegalFr from '../LegalFr';
import LegalPt from '../LegalPt';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

const renderLegalByLanguage = (licence, props) => {
  switch (licence) {
    case Licences.ES:
      return <LegalEs {...props} />;
    case Licences.DE:
      return <LegalDe {...props} />;
    case Licences.PT:
      return <LegalPt {...props} />;
    default:
      // $FlowFixMe
      return <LegalFr showAddiction={getLang() === Locales.FR} {...props} />;
  }
};

type LegalWrapperProps = {
  children: Node;
  licence: Licence;
  isVisible: boolean;
  connected: boolean;
  realMoney: boolean;
  handlePanicButtonPress?: () => void;
};

export const LegalWrapper = ({ children, licence, isVisible, ...rest }: LegalWrapperProps) => {
  const { navbarHeight, tabbarHeight } = useViewportContext();

  return (
    <Wrap $barsHeight={navbarHeight + tabbarHeight}>
      {/* Following divs are important to stick legal at bottom RM 122548 */}
      <div>{children}</div>
      {isVisible ? <div data-testid="legal">{renderLegalByLanguage(licence, rest)}</div> : null}
    </Wrap>
  );
};

export default React.memo<LegalWrapperProps>(LegalWrapper);
